module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgment")]), _vm._v(" "), _c('p', [_vm._v("We would like to thank all our clients for their trust in allowing us to contribute to their lives and successes. We make special mention of these individuals for their support and encouragement: Joe Armiento, Dick & Kate Cappon, Hazel Sutton-Christensen, Kim DuBrul, Linda & Randolph Fenn, Paul & Juanita Malysa, Tim & Deb Matz, Françoise Morissette, Don Park, Jean-François Pinsonnault, Ernest Pomerleau, Heather Preis, Alexander Preis, Timothy Rivlin, Brian Schwartz, Dr. Edith K. Smith and Lawrence Stibbards.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0